import { render, staticRenderFns } from "./VehicleRealtimeDetails.vue?vue&type=template&id=1e659d91"
import script from "./VehicleRealtimeDetails.vue?vue&type=script&lang=js"
export * from "./VehicleRealtimeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports